import { Outlet, ScrollRestoration } from 'react-router';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CookieBanner } from './CookieBanner';
import { GrainOverlay } from './GrainOverlay';

export function Layout() {
  return (
    <>
      <GrainOverlay />
      <div className="relative z-10 flex flex-col min-h-dvh">
        <Navbar />
        <main className="flex-1 pt-18">
          <Outlet />
        </main>
        <Footer />
      </div>
      <CookieBanner />
      <ScrollRestoration />
    </>
  );
}
